import { EmptyTableDisplay, useRouterParams } from "@zapier/shared";
import { useTranslations } from "@zapier/i18n";
import { EmptyAppsTable as EmptyAppsTableEnum } from "./useShowEmptyAppsTable";

interface Props {
  tableType: EmptyAppsTableEnum;
  onAddConnection?: () => void;
}

export function EmptyAppsTable({ tableType, onAddConnection }: Props) {
  const t = useTranslations("empty-apps-table");
  const { clearFilterParams } = useRouterParams();

  /* Empty Search */
  if (tableType === EmptyAppsTableEnum.EmptySearchResults) {
    return (
      <EmptyTableDisplay
        actionButtonText={t("buttons.clear-search")}
        headerText={t("headings.no-results-found")}
        icon="navSearch"
        onActionButton={() => clearFilterParams()}
        subHeaderText={t("messages.adjust-filters-or-clear-search")}
      />
    );
  }

  return (
    <EmptyTableDisplay
      icon="navConnectedAssets"
      headerText={t("headings.no-connections-added")}
      subHeaderText={t("messages.add-connection-to-automate")}
      actionButtonText={t("buttons.add-connection")}
      actionButtonIcon="formAdd"
      actionButtonColor="secondary"
      onActionButton={onAddConnection}
    />
  );
}
